// Shared ascending-by-tm_create comparator for the Case linked conversation
// panels (CaseConversationPanel, CaseCallTranscriptPanel) and the
// conversationMessages Redux slice -- extracted so the three copies that
// used to exist independently can't drift (SQUARE-55 round-2 review item 2).
//
// tm_create arrives with trailing fractional-second zeros trimmed (Go's time
// formatting), so two rows that differ only past the third fractional digit
// (e.g. "...00.123Z" vs "...00.1234Z") are NOT ordered correctly by plain
// string comparison -- and Date.parse can't fix that either, since JS Date
// only keeps millisecond precision and would treat both as identical.
// Padding the fractional digits to a common width before comparing keeps
// both magnitude and precision correct. Only the UTC "Z" suffix shape is
// normalized (the shape every tm_create in this codebase actually uses);
// anything else (a numeric offset, a space-separated datetime, an empty or
// missing value) is returned unchanged/empty and falls back to a plain
// string compare, same as before this fix.
export const normalizeTsForCompare = (v) => {
  const s = v || ''
  const m = s.match(/^([^.Z]*)(\.\d+)?(Z)$/)
  if (!m) return s
  const [, base, frac, tz] = m
  return `${base}.${(frac || '.').slice(1).padEnd(9, '0')}${tz}`
}

// Ascending (tm_create, id).
export const compareByTmCreateThenId = (a, b) =>
  normalizeTsForCompare(a.tm_create).localeCompare(normalizeTsForCompare(b.tm_create)) ||
  ((a.id || '').localeCompare(b.id || ''))
